module.exports = __webpack_public_path__ + "img/icon_process4.61ebfe01.png";